import { Component, Input, OnInit, TemplateRef, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { DefaultControlTemplate } from '../../interfaces';

@Component({
  selector: 'app-custom-form-control',
  standalone: true,
  imports: [CommonModule, MatIconModule, ReactiveFormsModule],
  templateUrl: './custom-form-control.component.html',
  styleUrls: ['./custom-form-control.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CustomFormControlComponent), multi: true }],
})
export class CustomFormControlComponent implements OnInit, ControlValueAccessor {
  isSelected: boolean = false;
  form!: FormGroup;

  onChanged: (value: boolean) => {};
  onTouched: any;

  // inputs
  @Input() customTemplate: TemplateRef<any>;
  @Input() defaultControlTemplate : DefaultControlTemplate ;

  // getters

  get control(): AbstractControl {
    return this.form.get('control');
  }
  constructor() {}

  // control value accessor methods
  writeValue(value: boolean): void {
    if (value) {
      this.isSelected = true;
    } else {
      this.isSelected = false;
    }
    this.control.setValue(this.isSelected);
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  //publics
  onClick() {
    if (!this.form.disabled) {
      this.isSelected = !this.isSelected;
    }
    this.onChanged(this.isSelected);
    this.onTouched();
  }

  // privates

  private initializeForm(): void {
    this.form = new FormGroup({
      control: new FormControl(this.isSelected),
    });
  }
}
